import React, { useState } from 'react';
import { AppBar, Toolbar, Grid, Typography, IconButton, Menu, MenuItem, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../../src/assets/images/logo/header_logo.png';
import WhatsAppFloatingButton from './WhatsAppFloatingButton';

const ScanMeHeader = ({ activeStep }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuHeight = activeStep === 0 ? '48px':'auto'

  return (
    <AppBar position="static" style={{ backgroundColor: '#00239b' }}>
      <Toolbar>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <img src={logo} alt="Company Logo" style={{ height: '40px', width: 'auto' }} />
          </Grid>
          {isMobile ? (
            <Grid item>
              <IconButton edge="end" color="inherit" aria-label="menu" onClick={handleMenuOpen}>
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                PaperProps={{
                  style: {
                    backgroundColor: '#00239b',
                    color: 'white',
                    height: menuHeight,
                  },
                }}
              >
                <MenuItem onClick={handleMenuClose} component={Link} to='/get-in-touch' sx={{ fontSize: '12px' }}>
                  Get in Touch
                </MenuItem>
                <MenuItem onClick={handleMenuClose} component={Link} to='/get-service-details' sx={{ fontSize: '12px' }}>
                  {activeStep === 0 ? '' : 'Assistance Benefits'}
                </MenuItem>
                <MenuItem onClick={handleMenuClose} component={Link} to='/terms-and-conditions' sx={{ fontSize: '12px' }}>
                  {activeStep === 0 ? '' : 'Terms & Conditions'}
                </MenuItem>
                
              </Menu>
            </Grid>
          ) : (
            <Grid item>
              <Grid container alignItems="center" spacing={6} sx={{mr: 8}}>
                <Grid item >
                  <Typography variant="body1" component={Link} to='/get-service-details' style={{ color: 'white', textDecoration: 'none', fontSize: '14px' }}>
                    {activeStep === 0 ? '' : 'Assistance Benefits'}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body1" component={Link} to='/terms-and-conditions' style={{ color: 'white', textDecoration: 'none', fontSize: '14px' }}>
                    {activeStep === 0 ? '' : 'Terms & Conditions'}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body1" component={Link} to='/get-in-touch' style={{ color: 'white', textDecoration: 'none', fontSize: '14px' }}>
                    Get in Touch
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Toolbar>
       <WhatsAppFloatingButton />
    </AppBar>
  );
};

export default ScanMeHeader;


